import _ from 'lodash';
import { PM_PROVIDERS } from 'common/constants/constants';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import useQueryParam from 'components/hooks/useQueryParam';
import { RESOURCE_TYPES } from './resource_types';

const DEFAULT_RESOURCE_TYPE_BY_PM_TOOL = {
  [PM_PROVIDERS.JIRA]: RESOURCE_TYPES.JIRA_PROJECTS,
  [PM_PROVIDERS.AZURE_BOARDS]: RESOURCE_TYPES.AZURE_PROJECTS
};

const useDefaultResourceType = defaultQueryStringParamName => {
  const defaultResourceQueryParam = useQueryParam({
    paramName: defaultQueryStringParamName,
    shouldOmit: true
  });
  const pmToolSensorId = useSelector(pmToolSensorIdSelector);

  const resourceTypeFromQuery = _.get(
    RESOURCE_TYPES,
    _.toUpper(defaultResourceQueryParam)
  );
  return (
    resourceTypeFromQuery || DEFAULT_RESOURCE_TYPE_BY_PM_TOOL[pmToolSensorId]
  );
};

export default useDefaultResourceType;
